import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { CSVExport, Search } from "react-bootstrap-table2-toolkit";
import Paper from "@mui/material/Paper";
import { handleSpringDataRequest } from "../../api/index";
import {
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  ClickAwayListener,
  FormControlLabel,
  FormGroup,
  Grid,
  Grow,
  IconButton,
  Popper,
  Tooltip,
} from "@mui/material";
import { unBlockMultipleRooms } from "../InventoryCalendar/api/InventoryApi";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-alpine.css";
import PDFExportPanel from "../Reports/pdfExport/PDFExportPanel";
import "ag-grid-enterprise";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import MockLoaderTable from "../Folios/ViewManagePayments/MockLoaderTable";
import Stack from "@mui/material/Stack";
import moment from "moment";
import TextField from "@mui/material/TextField";
import "react-responsive-modal/styles.css";
import { Modal } from "react-bootstrap";
import { getOOOReportForSelectedDate } from "./HouseKeepingApi";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import i18n from "../../modules/Auth/pages/i18n";

function OutOfOrderReport(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);
  const hotelId = props.data.hotelId;
  const [products, setProducts] = useState();
  const [mockloader, setMockloader] = useState(false);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;

  const reportType = "Out of order report";

  // filter params for the date filter
  const filterParams = {
    debounceMs: 500,
    suppressAndOrCondition: true,
    comparator: function (filterLocalDateAtMidnight, cellValue) {
      if (cellValue == null) {
        return 0;
      }
      //   console.log(moment(dateParts).format("DD-MM-YYYY"))
      var dateParts = moment(cellValue).format("DD-MM-YYYY");
      const formattedDateParts = dateParts.split("-");
      var year = Number(formattedDateParts[2]);
      var month = Number(formattedDateParts[1]) - 1;
      var day = Number(formattedDateParts[0]);
      var cellDate = new Date(year, month, day);

      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      } else if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    },
  };

  // defining variables and setting the state
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [selectedRowsLength, setSelectedRowsLength] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState(null);
  const [rowsData, setRowsData] = useState(null);

  const columns = [
    {
      field: "id",
      headerName: `${t("ID")}`,
      filter: "agNumberColumnFilter",
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      field: "room_number",
      headerName: `${t("Room Number(s)")}`,
      filter: "agNumberColumnFilter",
    },
    {
      field: "log_message",
      headerName: `${t("Reason")}`,
    },
    {
      field: "startDate",
      headerName: `${t("Start Date")}`,
      // filter: "agDateColumnFilter",
      // floatingFilterComponentParams: {
      //   suppressFilterButton: true,
      // },
      // filterParams: filterParams,
    },
    {
      field: "endDate",
      headerName: `${t("End Date")}`,
      // filter: "agDateColumnFilter",
      // floatingFilterComponentParams: {
      //   suppressFilterButton: true,
      // },
      // filterParams: filterParams,
    },
    {
      field: "logTime",
      headerName: `${t("Log date and time")}`,
      // filter: "agDateColumnFilter",
      // valueFormatter: (params) => params.value,
    },
  ];

  const gridOptions = {
    pagination: true,
    rowSelection: "multiple",
  };

  // default column properties
  const defaultColDefs = {
    sortable: true, //sort the table
    floatingFilter: true, // getting the filter below the columns
    tooltipField: "name",
    filter: "agMultiColumnFilter", // setting the multi column filter for the table
    display: "subMenu", // how the text filter and the set filter will look like
    resizable: true,
    flex: 1,
  };

  // assigning the data to the grid api and calling the external API
  // on grid ready function
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  // const getOOOReport = () => {
  //   handleSpringDataRequest(
  //     `core/api/v1/hk/get-ooo-report?fromDate=${moment(
  //       `${value[0].startDate}`
  //     ).format("DD-MM-yyyy")}&endDate=${moment(`${value[0].endDate}`).format(
  //       "DD-MM-yyyy"
  //     )}&isUpdate=${checked}&${hotelId}`
  //   )
  //     .then((res) => {
  //       setMockloader(true);
  //       setRowsData(res);
  //       setMockloader(false);
  //     })
  //     .catch((err) => console.log(err));
  // };
  // useEffect(() => {
  //   getOOOReport();
  // }, []);

  const [loader, setloader] = useState(false);

  const makeRoomAvailable = async () => {
    const data = rowsData.filter(function (el) {
      return selectedRows.indexOf(el.id) > -1;
    });
    const response = selectedRows?.map(function (el) {
      return {
        physicalRoomIds: el.room_number.replace(/ /g, "").split(","),
        startDate: moment(el.startDate).format("DD-MM-YYYY HH:MM:SS"),
        endDate: moment(el.endDate).format("DD-MM-YYYY HH:MM:SS"),
        datesText: "Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday",
        id: `${el.startDate} - ${el.endDate}Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday`,
        text: "",
        reason: "",
      };
    });
    response.map((res) => {
      const temparr = [];
      res.physicalRoomIds.map((roomID) => {
        if (roomIDMap.has(roomID) && roomIDMap.get(roomID))
          temparr.push(roomID);
      });
      res.physicalRoomIds = temparr;
    });
    setloader(true);
    const res = await unBlockMultipleRooms(response);
    setloader(false);
    // getOOOReport();
    applyDateRange();

    if (res === "Operation Successful") {
      toast.success(`${t("Successfully unblocked rooms")}`);
    } else {
      toast.error(`${t("Something went wrong")}`);
    }
    onCloseMakeRoomAvaiableModal();
  };

  // Calling the grid api and then exporting the data into the csv format
  const onExportClick = () => {
    selectedRowsLength === 0
      ? gridApi.exportDataAsCsv({
          processCellCallback: (params) => {
            if (params.column.getColId() === "room_number") {
              return `'${params.value}'`;
            }
            return `${params.value}`;
          },
        })
      : gridApi.exportDataAsCsv({
          onlySelected: true,
          processCellCallback: (params) => {
            if (params.column.getColId() === "room_number") {
              return `'${params.value}'`;
            }
            return `${params.value}`;
          },
        });
  };

  //  Exporting it in the Excel format
  const onExportExcel = () => {
    selectedRowsLength === 0
      ? gridApi.exportDataAsExcel()
      : gridApi.exportDataAsExcel({ onlySelected: true });
  };

  // Open PDF Modal
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const onOpenPdfModal = () => setOpenPdfModal(true);
  const onClosePdfModal = () => setOpenPdfModal(false);

  const getDownloadType = (dType) => {
    dType === "1" && onExportClick();
    dType === "2" && onOpenPdfModal();
    dType === "3" && onExportExcel();
  };

  const [pickDate, setPickDate] = useState(new Date());

  // quick search
  const onFilterTextChange = (event) => {
    // console.log(event.target.value)
    setFilterCount((prevCount) => prevCount + 1);
    // console.log("filterCount", filterCount)
    gridApi.setQuickFilter(event.target.value);
  };

  // dynamically change the page size
  const onPaginationChange = (pageSize) => {
    gridApi.paginationSetPageSize(pageSize);
    console.log("");
  };

  const handleChange = async (newValue) => {
    setPickDate(newValue);

    // getOOOReport();
  };

  /* SELECTED BOOKING ID */
  // using the booking id
  const [selectedBookingId, setSelectedBookingId] = useState(null);

  const [roomIDMap, setRoomIDMap] = useState();
  const [roomIDarr, setRoomIDarr] = useState();

  // On selection of a row get its data
  const onSelectionChanged = (event) => {
    setSelectedRowsLength(event.api.getSelectedRows().length);
    setSelectedRows(event.api.getSelectedRows());
    const temprows = event.api.getSelectedRows();
    const newarr = [];
    const roomMap = new Map();
    temprows.map((item) => {
      const rooms = item.room_number.split(",");
      rooms.map((res) => {
        newarr.push(res);
        roomMap.set(res, true);
      });
    });
    setRoomIDarr(newarr);
    setRoomIDMap(roomMap);
    const selectedBooking_Id = event.api.getSelectedRows()[0]?.bookingid;
    setSelectedBookingId(selectedBooking_Id);
    // console.log("Selected rows length", event.api.getSelectedRows().length)
  };

  const getDateText = () => {
    let val = "";
    val = val + moment(value[0].startDate).format("DD MMM YYYY") + " - ";
    val = val + moment(value[0].endDate).format("DD MMM YYYY");
    return val;
  };

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [anchorElDate, setAnchorElDate] = useState(null);
  const [numDays, setNumDays] = useState(3);

  const [value, setValue] = useState([
    {
      startDate: new Date(),
      endDate: new Date(new Date().setDate(new Date().getDate() + numDays)),
      key: "selection",
    },
  ]);

  // useEffect(() => {
  //   getDateText();
  // }, [value]);
  // useEffect(async () => {
  //   setMockloader(true);
  //   const data = await getOOOReportForSelectedDate(
  //     moment(`${value[0].startDate}`).format("DD-MM-yyyy"),
  //     moment(`${value[0].endDate}`).format("DD-MM-yyyy"),
  //     checked
  //   );
  //   setRowsData(data);
  //   setMockloader(false);
  // }, [value, checked]);

  const [checked, setChecked] = React.useState(0);

  const applyDateRange = async () => {
    setMockloader(true);
    const data = await getOOOReportForSelectedDate(
      moment(`${value[0].startDate}`).format("DD-MM-yyyy"),
      moment(`${value[0].endDate}`).format("DD-MM-yyyy"),
      checked === "1" ? true : false
    );
    setRowsData(data);
    setMockloader(false);
  };

  useEffect(() => {
    applyDateRange();
  }, [checked]);

  //open makeRoomAvaiable modal
  const [openMakeRoomAvaiable, setOpenMakeRoomAvaiable] = useState(false);
  const onOpenMakeRoomAvaiableModal = () => setOpenMakeRoomAvaiable(true);
  const onCloseMakeRoomAvaiableModal = () => setOpenMakeRoomAvaiable(false);

  return (
    <>
      <div className="oooReportTable">
        <div className="nameHeaderWrapper">
          <h3 style={{ marginLeft: "1rem", marginBottom: "1rem" }}>
            {t(
              "This report gives an idea of which all rooms are Out Of Order with reasons if added at the time of blocking rooms. Also, it gives a log of the operation performed."
            )}
          </h3>
          <div className="headerOptions">
            <Stack direction="row" style={{ width: "100%" }}>
              <div
                className="d-flex justify-content-between"
                style={{ width: "100%" }}
              >
                <div className="d-flex">
                  <div className="searchFunctionality">
                    <input
                      className="searchInp"
                      type="search"
                      onChange={onFilterTextChange}
                      placeholder={t("Search...")}
                    />
                  </div>
                  <div className="paginationWrapper">
                    <select
                      className="paginationSelection"
                      onChange={(e) => onPaginationChange(e.target.value)}
                    >
                      <option value="50">50</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <div className="datePicker">
                    {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Pick your date"
                    inputFormat="MM/dd/yyyy"
                    value={pickDate}
                    onChange={handleChange}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                </LocalizationProvider> */}
                    <ClickAwayListener
                      onClickAway={() => {
                        setShowDatePicker(false);
                        setAnchorElDate(null);
                      }}
                      style={{ width: "20rem", height: "2px" }}
                    >
                      <div>
                        <TextField
                          style={{
                            width: "20rem",
                            // height: "2px",
                            // padding: "8px !important",
                          }}
                          focused={showDatePicker}
                          InputProps={{ readOnly: true }}
                          value={getDateText()}
                          size="small"
                          label={t("Date range")}
                          onClick={(eve) => {
                            setAnchorElDate(eve.currentTarget);
                            setShowDatePicker(true);
                          }}
                        ></TextField>
                        {showDatePicker && (
                          <Popper
                            style={{ zIndex: 2 }}
                            open={showDatePicker}
                            anchorEl={anchorElDate}
                            placement="bottom"
                            transition
                            disablePortal
                          >
                            {({ TransitionProps, placement }) => (
                              <Grow
                                style={{
                                  transformOrigin: (placement = "bottom-end"),
                                }}
                                {...TransitionProps}
                              >
                                <Paper elevation={5}>
                                  <DateRange
                                    color="#1BC5BD"
                                    rangeColors={["#1BC5BD"]}
                                    editableDateInputs={false}
                                    dragSelectionEnabled={false}
                                    months={1}
                                    // onChange={(data) => {
                                    //   console.log("data range is : ", data);
                                    //   setValue([{ ...data.range1 }]);
                                    // }}
                                    onChange={(item) => {
                                      setValue([{ ...item.selection }]);
                                    }}
                                    ranges={value}
                                  ></DateRange>
                                  <Grid
                                    container
                                    item
                                    sx={{
                                      padding: 1,
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Button
                                      color="primary"
                                      onClick={() => {
                                        applyDateRange();
                                        setShowDatePicker(false);
                                      }}
                                    >
                                      {t("Apply")}
                                    </Button>
                                  </Grid>
                                </Paper>
                              </Grow>
                            )}
                          </Popper>
                        )}
                      </div>
                    </ClickAwayListener>
                  </div>
                  <div
                    className="exportWrapper"
                    style={{ marginRight: "2rem" }}
                  >
                    {/* <BsIcons.BsDownload size="17" color="black" /> */}
                    <select
                      value={checked}
                      className="exportOptionsWrapper"
                      onChange={(e) => setChecked(e.target.value)}
                    >
                      <option value="0" selected>
                        {t("Out of order date")}
                      </option>
                      <option value="1"> {t("Update time")}</option>
                    </select>
                  </div>

                  {/* <div className="d-flex align-items-center ml-3">
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={handleChanges}
                      style={{ marginBottom: "0px" }}
                    />
                    <p className="mb-0 ml-2" style={{ fontSize: "17px" }}>
                      isUpdate
                    </p>
                  </div> */}
                  <div>
                    {/* <Button
                      className="ml-3"
                      variant="custom-button"
                      onClick={onOpenMakeRoomAvaiableModal}
                    >
                      Bulk room available 
                    </Button> */}
                    {/* <Tooltip title="This report gives an idea of which all rooms are not for sale along with reasons if added at the time of blocking rooms.">
                      <IconButton>
                        <InfoIcon />
                      </IconButton>
                    </Tooltip> */}
                  </div>
                </div>

                <div className="exportWrapper" style={{ marginRight: "2rem" }}>
                  {/* <BsIcons.BsDownload size="17" color="black" /> */}
                  <select
                    value="0"
                    className="exportOptionsWrapper"
                    onChange={(e) => getDownloadType(e.target.value)}
                  >
                    <option value="0" selected>
                      {t("Export As...")}
                    </option>
                    <option value="1"> {t("Export as CSV")}</option>
                    <option value="2"> {t("Export as PDF")}</option>
                    <option value="3"> {t("Export as Excel")}</option>
                  </select>
                </div>
              </div>
            </Stack>
          </div>
          {/* </div> */}
          <div className="oooAgTable">
            <div className="ag-theme-alpine">
              {rowsData ? (
                <AgGridReact
                  className="agGridTable"
                  rowData={rowsData}
                  onGridReady={onGridReady}
                  columnDefs={columns}
                  defaultColDef={defaultColDefs}
                  enableBrowserTooltips={true}
                  onSelectionChanged={onSelectionChanged}
                  rowMultiSelectWithClick={true}
                  paginationPageSize={50}
                  alwaysShowBothConditions={true}
                  // groupIncludeTotalFooter = {true}
                  sideBar={{
                    toolPanels: [
                      {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                      },
                    ],
                    defaultToolPanel: "none",
                  }}
                  groupMultiAutoColumn={true}
                  suppressAggFuncInHeader={true}
                  // groupRowAggNodes = {getTotalValue}
                  // suppressAggFilteredOnly = {true}
                  // getRowNodeId= {getRowNodeId}
                  statusBar={{
                    statusPanels: [
                      {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left",
                      },
                      {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center",
                      },
                      { statusPanel: "agFilteredRowCountComponent" },
                      { statusPanel: "agSelectedRowCountComponent" },
                      { statusPanel: "agAggregationComponent" },
                    ],
                  }}
                  gridOptions={gridOptions}
                />
              ) : (
                <MockLoaderTable />
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        show={openPdfModal}
        onHide={onClosePdfModal}
        center
      >
        <div className="pdfExportWrapper" style={{ marginLeft: "1.5rem" }}>
          <PDFExportPanel
            gridApi={gridApi}
            columnApi={gridColumnApi}
            report_Type={reportType}
            startdate={moment(pickDate).format("MMM DD YYYY")}
            enddate={moment(pickDate).format("MMM DD YYYY")}
            housekeepingReport={true}
            selectedLanguage={props.selectedLanguage}
            // numEnteries={numEnteries}
            // selectedNumEnteries={selectedNumEnteries}
          />
        </div>
      </Modal>

      {/* Opening modal while marking the rooms bulk dirty and assigning staff */}
      <Modal
        classNames={{ overlay: "customOverlay", modal: "customModal" }}
        show={openMakeRoomAvaiable}
        onHide={onCloseMakeRoomAvaiableModal}
        center
      >
        <div className="handleBulkDirtyWrapper">
          <div
            style={{
              borderBottom: "1px solid #DDDDDD",
              paddingBottom: "10px",
              marginBottom: "10px",
              marginTop: "1rem",
              marginLeft: "1rem",
              fontSize: "1.5rem",
              fontWeight: "bold",
            }}
          >
            {t("Bulk room available")}
          </div>
          {selectedRows && (
            <div
              className="selectedRoomIdsChip"
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="selectedRoomIdLabel"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  marginLeft: "1rem",
                }}
              >
                {t("Selected room number:")}
              </div>
              <FormGroup
                className="selectedRoomIds"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {roomIDarr !== undefined &&
                  roomIDarr.map((item) => {
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            defaultChecked
                            onChange={(e) => {
                              const tempstate = roomIDMap;
                              tempstate.set(item, e.target.checked);
                              setRoomIDMap(tempstate);
                            }}
                          />
                        }
                        label={item}
                      />
                    );
                  })}
              </FormGroup>
            </div>
          )}
          <div
            className="buttons"
            style={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "10px",
              borderTop: "1px solid #DDDDDD",
              paddingTop: "10px",
              marginBottom: "1rem",
            }}
          >
            <Button variant="secondary" onClick={onCloseMakeRoomAvaiableModal}>
              {t("Close")}
            </Button>
            <Button
              variant="custom-button"
              style={{ marginRight: "1rem" }}
              onClick={makeRoomAvailable}
            >
              {!loader ? `${t("Confirm")}` : <CircularProgress size="15px" />}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(OutOfOrderReport);
